import Vue from 'vue'
import { Logger, LogLevel } from '@/utils/logger'

export default class EventBusService {
  logger: Logger

  eventBus: Vue

  constructor() {
    this.logger = new Logger(LogLevel.DEBUG)
    this.eventBus = new Vue()
  }

  public on(event: string | string[], callback: Function): void {
    this.logger.debug('EventBusService on() event：', event)
    this.eventBus.$on(event, callback)
  }

  public off(event: string | string[], callback?: Function): void {
    this.logger.debug('EventBusService off() event：', event)
    this.eventBus.$off(event, callback)
  }

  public emit(event: string, ...args: any[]): void {
    this.logger.debug('EventBusService emit() event：', event)
    this.eventBus.$emit(event, ...args)
  }
}
